export default __webpack_public_path__ + "static/logo-40b04bc61a42c02de4407c46cc99974c.svg";